import { render, staticRenderFns } from "./wapHeaderNew.vue?vue&type=template&id=ca422626&scoped=true&"
import script from "./wapHeaderNew.vue?vue&type=script&lang=js&"
export * from "./wapHeaderNew.vue?vue&type=script&lang=js&"
import style0 from "./wapHeaderNew.vue?vue&type=style&index=0&id=ca422626&lang=css&scoped=true&"
import style1 from "./wapHeaderNew.vue?vue&type=style&index=1&id=ca422626&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca422626",
  null
  
)

export default component.exports